/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/layout';
var nationwideRouter = [{
  path: '/',
  name: 'workbenchnationwide',
  component: Layout,
  children: [{
    path: 'workbenchnationwide',
    component: function component() {
      return import('@/views/gov/workbenchnationwide');
    },
    meta: {
      title: '工作台',
      icon: 'nav_workbench',
      roles: ['superadmin', "superadmin_03"]
    }
  }]
}, {
  path: '/',
  name: 'chnationwidedatareport',
  component: Layout,
  meta: {
    title: '数据分析',
    icon: 'nav_data',
    roles: ['superadmin']
  },
  children: [{
    path: 'chnationwidevision',
    component: function component() {
      return import('@/views/nationwide/data/chnationwidevision');
    },
    meta: {
      title: '视力数据分析'
    }
  }, {
    path: 'chnationwideillness',
    component: function component() {
      return import('@/views/nationwide/data/chnationwideillness');
    },
    meta: {
      title: '常见病数据分析'
    }
  },
  // {
  //   path: 'chnationwideinspection',
  //   component: () => import('@/views/nationwide/data/chnationwideinspection'),
  //   meta: { title: '行为影响因素监测' }
  // },

  // {
  //   path: 'chnationwidedisease',
  //   component: () => import('@/views/nationwide/data/chnationwidedisease'),
  //   meta: { title: '学生缺课监测' }
  // },
  // 上面一个演示用
  {
    path: 'chnationwidesanitation',
    component: function component() {
      return import('@/views/nationwide/data/chnationwidesanitation');
    },
    meta: {
      title: '学校卫生工作情况监测'
    }
  }
  // {
  //   path: 'chnationwidechildhealth',
  //   component: () => import('@/views/nationwide/data/chnationwideChildHealth'),
  //   meta: { title: '儿童保健数据分析' }
  // },
  // 下面一个演示用
  // {
  //   path: 'chnationwidehealth',
  //   component: () => import('@/views/nationwide/data/chnationwidehealth'),
  //   meta: { title: '教学生活环境卫生监测', },
  // },

  // 新版数据分析报告
  // {
  //   path: 'chnationwidehealthNew',
  //   component: () => import('@/views/nationwide/data/chnationwidehealthNew'),
  //   meta: { title: '学校卫生工作' }
  // }
  ]
},
// 功能分类
{
  path: '/nationwide/functionally',
  name: 'functionally',
  component: Layout,
  meta: {
    title: '常用功能',
    icon: 'nav_functive',
    roles: ['superadmin', "superadmin_03"]
  },
  children: [{
    path: 'manage',
    component: function component() {
      return import('@/views/nationwide/functionally/manage');
    },
    meta: {
      title: '账号管理',
      roles: ['superadmin', "superadmin_03"]
    }
  }, {
    path: "govimports",
    component: function component() {
      return import("@/views/gov/gov-imports");
    },
    meta: {
      title: "数据文件管理",
      roles: ["superadmin_03"]
    }
  }, {
    path: 'task',
    component: function component() {
      return import('@/views/gov/task');
    },
    meta: {
      title: '任务管理',
      roles: ['superadmin']
    }
  }, {
    path: 'questionnaire',
    component: function component() {
      return import('@/views/gov/questionnaire2');
    },
    meta: {
      title: '调查问卷',
      roles: ['superadmin']
    }
  }, {
    path: 'progress',
    component: function component() {
      return import('@/views/nationwide/progress');
    },
    meta: {
      title: '筛查进度',
      roles: ['superadmin']
    }
  }, {
    path: 'assess',
    component: function component() {
      return import('@/views/screen/assess/index');
    },
    meta: {
      title: '质量控制',
      roles: ['superadmin']
    }
  }, {
    path: 'contrast',
    component: function component() {
      return import('@/views/nationwide/contrast');
    },
    meta: {
      title: '抽样对比',
      roles: ['superadmin']
    }
  }, {
    path: 'export',
    component: function component() {
      return import('@/views/gov/export');
    },
    meta: {
      title: '导出数据',
      roles: ['superadmin']
    }
  }, {
    path: 'science',
    component: function component() {
      return import('@/views/gov/operationlog');
    },
    meta: {
      title: '操作日志',
      roles: ['superadmin']
    }
  },
  // {
  //   path: 'notify',
  //   component: () => import('@/views/gov/notify'),
  //   meta: { title: '消息中心', roles: ['province', 'city', 'district'] }
  // },
  {
    path: "helpcenter",
    component: function component() {
      return import("@/views/screen/helpcenter");
    },
    meta: {
      title: "帮助中心",
      roles: ["superadmin"]
    }
  }, {
    path: 'datamanage',
    component: function component() {
      return import('@/views/nationwide/functionally/datamanage');
    },
    meta: {
      title: '数据管理',
      roles: ['superadmin', "superadmin_03"]
    }
  }
  // {
  //   path: 'export',
  //   component: () => import('@/views/gov/manage/export'),
  //   meta: { title: '下载文件',roles: ['district'] }
  // },
  // {
  //   path: 'notify',
  //   component: () => import('@/views/gov/notify'),
  //   meta: { title: '消息中心',roles: ['province', 'city', 'district', 'superadmin'] }
  // },
  // {
  //   path: 'checksetting',
  //   component: () => import('@/views/gov/checksetting'),
  //   meta: { title: '检查项目设置',roles: ['province', 'city', 'district', 'superadmin'] }
  // },
  // {
  //   path: 'set',
  //   component: () => import('@/views/gov/set'),
  //   meta: { title: '检查项目设置',icon: 'ope',roles: ['province', 'city', 'district', 'superadmin'] }
  // },

  // {
  //   path: 'contagion',
  //   component: () => import('@/views/gov/contagion'),
  //   meta: { title: '疾病症状库',roles: ['superadmin','province', 'city', 'district'] }
  // },
  ]
}, {
  path: '',
  component: Layout,
  hidden: true,
  children: [{
    path: '/gov/govfile',
    name: 'govfile',
    component: function component() {
      return import('@/views/gov/govfile');
    },
    meta: {
      title: '学生档案',
      roles: ['province', 'city', 'superadmin', 'district']
    }
  }]
}, {
  path: '',
  component: Layout,
  hidden: true,
  children: [{
    path: '/nationwide/total',
    name: 'nationwidetotal',
    component: function component() {
      return import('@/views/gov/report/workbenchtotal');
    },
    meta: {
      title: '数据总览',
      roles: ['superadmin']
    }
  }]
}, {
  path: '/nationwide/account',
  name: 'account',
  component: Layout,
  hidden: true,
  meta: {
    title: '机构管理',
    icon: 'account',
    roles: ['superadmin']
  },
  children: [{
    path: 'nationwide',
    component: function component() {
      return import('@/views/nationwide/functionally/gov');
    },
    meta: {
      title: '管理机构账号分配'
    }
  }, {
    path: 'screen',
    component: function component() {
      return import('@/views/nationwide/functionally/screen');
    },
    meta: {
      title: '筛查机构账号分配'
    }
  }
  // {
  //   path: 'school',
  //   component: () => import('@/views/screen/account/schoolaccount'),
  //   meta: { title: '学校账号管理', roles: ['district'] }
  // }
  ]
},
//  国级
{
  path: '/nationwide/progress',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'nationwide/progress',
    component: function component() {
      return import('@/views/nationwide/progress');
    },
    meta: {
      title: '筛查进度',
      icon: 'progress',
      roles: ['superadmin']
    }
  }]
},
//  省级
{
  path: '/nationwide/progress/progressprovince',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'nationwide/progress/progressprovince',
    component: function component() {
      return import('@/views/nationwide/progressprovince');
    },
    meta: {
      title: '筛查进度',
      icon: 'progress',
      roles: ['superadmin']
    }
  }]
},
// 市级
{
  path: '/nationwide/progress/progresscity',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'nationwide/progress/progresscity',
    component: function component() {
      return import('@/views/nationwide/progresscity');
    },
    meta: {
      title: '筛查进度',
      icon: 'progress',
      roles: ['superadmin']
    }
  }]
},
// 区县级
{
  path: '/nationwide/progress/progressdistrict',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'nationwide/progress/progressdistrict',
    hidden: true,
    component: function component() {
      return import('@/views/nationwide/progressdistrict');
    },
    meta: {
      title: '筛查进度',
      icon: 'progress',
      roles: ['superadmin']
    }
  }]
},
// 校级
{
  path: '/nationwide/progress/progressschool',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'nationwide/progress/progressschool',
    hidden: true,
    component: function component() {
      return import('@/views/nationwide/progressschool');
    },
    meta: {
      title: '筛查进度',
      icon: 'progress',
      roles: ['superadmin']
    }
  }]
},
// 校级详细信息
// {
//   path: '/nationwide/progress/progressdetail',
//   component: Layout,
//   hidden: true,
//   children: [
//     {
//       path: '',
//       name: 'nationwide/progress/progressdetail',
//       hidden: true,
//       component: () => import('@/views/nationwide/progressdetail'),
//       meta: { title: '筛查进度', icon: 'progress', roles: ['superadmin'] },

//     }
//   ]
// },

{
  path: '/nationwide/contrast',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'contrast',
    component: function component() {
      return import('@/views/nationwide/contrast');
    },
    meta: {
      title: '抽样对比',
      icon: 'vs',
      roles: ['superadmin']
    }
  }]
}, {
  path: '/nationwide/schoolnationwide',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'schoolnationwide',
    component: function component() {
      return import('@/views/nationwide/schoolnationwide');
    },
    meta: {
      title: '学校数据分析',
      icon: 'campus',
      roles: ['superadmin']
    }
  }]
}, {
  path: '/nationwide/schoolprovince',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'schoolprovince',
    component: function component() {
      return import('@/views/nationwide/schoolprovince');
    },
    meta: {
      title: '学校数据分析',
      icon: 'campus',
      roles: ['superadmin']
    }
  }]
}, {
  path: '/nationwide/schoolcity',
  component: Layout,
  meta: {
    roles: ['superadmin']
  },
  hidden: true,
  children: [{
    path: '',
    name: 'schoolcity',
    component: function component() {
      return import('@/views/nationwide/schoolcity');
    },
    meta: {
      title: '市级内学校数据分析',
      icon: 'campus'
    }
  }]
}, {
  path: '/nationwide/schoolcitydistrict',
  component: Layout,
  hidden: true,
  meta: {
    roles: ['superadmin']
  },
  children: [{
    path: '',
    name: 'schoolcitydistrict',
    component: function component() {
      return import('@/views/nationwide/schoolcitydistrict');
    },
    meta: {
      title: '区/县内学校数据分析',
      icon: 'campus'
    }
  }]
}, {
  path: '/gov/aera',
  name: 'aeradatareport',
  hidden: true,
  component: Layout,
  meta: {
    title: '数据分析',
    icon: 'chinamap',
    roles: ['superadmin']
  },
  children: [{
    path: 'province',
    component: function component() {
      return import('@/views/gov/data/govvision');
    },
    meta: {
      title: '省级视力数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwidevision'
    }
  }, {
    path: 'provinceilless',
    component: function component() {
      return import('@/views/gov/data/govillness');
    },
    meta: {
      title: '省级常见病数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwideillness'
    }
  }, {
    path: 'provinceinspection',
    component: function component() {
      return import('@/views/gov/report/data/provinceinspection');
    },
    meta: {
      title: '省级行为影响因素数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwideinspection'
    }
  }, {
    path: 'provincedisease',
    component: function component() {
      return import('@/views/gov/report/data/provincedisease');
    },
    meta: {
      title: '省级学生因病缺课监测数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwidedisease'
    }
  }, {
    path: 'provincehealth',
    component: function component() {
      return import('@/views/gov/report/data/provincehealth');
    },
    meta: {
      title: '省级教学生活环境卫生监测数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwidehealth'
    }
  }, {
    path: 'provincesanitation',
    component: function component() {
      return import('@/views/gov/report/data/provincesanitation');
    },
    meta: {
      title: '省级学校卫生工作情况监测数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwidesanitation'
    }
  },
  // 市级
  {
    path: 'city',
    component: function component() {
      return import('@/views/gov/report/data/city');
    },
    meta: {
      title: '市级数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwidevision'
    }
  }, {
    path: 'cityilless',
    component: function component() {
      return import('@/views/gov/report/data/cityilless');
    },
    meta: {
      title: '市级常见病数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwideillness'
    }
  }, {
    path: 'cityinspection',
    component: function component() {
      return import('@/views/gov/report/data/cityinspection');
    },
    meta: {
      title: '市级行为影响因素数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwideinspection'
    }
  }, {
    path: 'citydisease',
    component: function component() {
      return import('@/views/gov/report/data/citydisease');
    },
    meta: {
      title: '市级学生因病缺课监测数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwidedisease'
    }
  }, {
    path: 'cityhealth',
    component: function component() {
      return import('@/views/gov/report/data/cityhealth');
    },
    meta: {
      title: '市级教学生活环境卫生监测数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwidehealth'
    }
  }, {
    path: 'citysanitation',
    component: function component() {
      return import('@/views/gov/report/data/citysanitation');
    },
    meta: {
      title: '市级学校卫生工作情况监测数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwidesanitation'
    }
  },
  // 区县级
  {
    path: 'district',
    component: function component() {
      return import('@/views/gov/report/data/district');
    },
    meta: {
      title: '区/县级数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwidevision'
    }
  }, {
    path: 'districtill',
    component: function component() {
      return import('@/views/gov/report/data/districtill');
    },
    meta: {
      title: '区/县级常见病数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwideillness'
    }
  }, {
    path: 'districtinspection',
    component: function component() {
      return import('@/views/gov/report/data/districtinspection');
    },
    meta: {
      title: '区/县级行为影响因素数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwideinspection'
    }
  }, {
    path: 'districtdisease',
    component: function component() {
      return import('@/views/gov/report/data/districtdisease');
    },
    meta: {
      title: '区/县级学生因病缺课监测数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwidedisease'
    }
  }, {
    path: 'districthealth',
    component: function component() {
      return import('@/views/gov/report/data/districthealth');
    },
    meta: {
      title: '区/县级教学生活环境卫生监测数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwidehealth'
    }
  }, {
    path: 'districtsanitation',
    component: function component() {
      return import('@/views/gov/report/data/districtsanitation');
    },
    meta: {
      title: '区/县级学校卫生工作情况监测数据分析',
      roles: ['superadmin'],
      activeMenu: '/chnationwidesanitation'
    }
  }

  // {
  //   path: 'rankingofmyopia',
  //   component: () => import('@/views/gov/report/rankingofmyopia'),
  //   meta: { title: '近视率排行', roles: ['superadmin',] }
  // },
  // {
  //   path: 'rankingofmyopiacity',
  //   component: () => import('@/views/gov/report/rankingofmyopiacity'),
  //   meta: { title: 'hide', roles: ['superadmin',] }
  // },
  // {
  //   path: 'rankingofeye',
  //   component: () => import('@/views/gov/report/rankingofeye'),
  //   meta: { title: '视力低下率排行', roles: ['superadmin',] }
  // },
  // {
  //   path: 'rankingofeyecity',
  //   component: () => import('@/views/gov/report/rankingofeyecity'),
  //   meta: { title: 'hide', roles: ['superadmin',] }
  // },
  ]
}, {
  path: '/nationwide/personal',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'personal',
    component: function component() {
      return import('@/views/gov/personal');
    },
    meta: {
      title: '个案数据分析',
      icon: 'people',
      roles: ['superadmin']
    }
  }]
}, {
  path: '/nationwide/rankingofmyopia',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'rankingofmyopia',
    component: function component() {
      return import('@/views/nationwide/report/rankingofmyopia');
    },
    meta: {
      title: '近视率排行',
      roles: ['superadmin']
    }
  }]
}, {
  path: '/nationwide/rankingofeye',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'rankingofeye',
    component: function component() {
      return import('@/views/nationwide/report/rankingofeye');
    },
    meta: {
      title: '视力低下率排行',
      roles: ['superadmin']
    }
  }]
}, {
  path: '/nationwide/questionnaire',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'questionnaire',
    component: function component() {
      return import('@/views/nationwide/questionnaire');
    },
    meta: {
      title: '调查问卷',
      icon: 'questionnaire',
      roles: ['superadmin']
    }
  }]
}, {
  path: '/gov/export',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'export',
    component: function component() {
      return import('@/views/gov/export');
    },
    meta: {
      title: '下载文件',
      icon: 'export',
      roles: ['province', 'city', 'district', 'superadmin']
    }
  }]
}, {
  path: '/nationwide/operationlog',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'operationlog',
    component: function component() {
      return import('@/views/gov/operationlog');
    },
    meta: {
      title: '操作日志',
      icon: 'operationlog',
      roles: ['superadmin']
    }
  }]
}];
export default nationwideRouter;